module.exports = __webpack_public_path__ + "static/ren-t-b841da3d9726a450afca9c0c6361e983.png";